import type { explorerCatalog } from "@/lib/chat/catalog";
import type { templateStudioCatalog } from "@/lib/template-studio/catalog";

type ExplorerCatalogComponentKey =
  keyof (typeof explorerCatalog)["data"]["components"];

type ReportCatalogComponentKey =
  keyof (typeof templateStudioCatalog)["data"]["components"];

/** Herald body components from the chat catalog that template slots may accept. */
export const templateHeraldSlotContentTypes = [
  "AreaChart",
  "BarChart",
  "ComposedChart",
  "DataList",
  "HorizontalBar",
  "Image",
  "LineChart",
  "Markdown",
  "Metric",
  "MetricGroup",
  "PieChart",
  "RadarChart",
  "RadialBarChart",
  "StackedBarChart",
  "Table",
] as const satisfies readonly ExplorerCatalogComponentKey[];

const templateReportSlotContentTypes = [
  "ReportDate",
  "ReportFooter",
  "ReportHeader",
  "ReportHighlight",
  "ReportSection",
] as const satisfies readonly ReportCatalogComponentKey[];

export type TemplateSlotContentType =
  | (typeof templateHeraldSlotContentTypes)[number]
  | (typeof templateReportSlotContentTypes)[number];

export const TEMPLATE_SLOT_INPUT_MODES = ["prompt", "text"] as const;

export type TemplateSlotInputMode = (typeof TEMPLATE_SLOT_INPUT_MODES)[number];

export const getDefaultTemplateSlotInputMode = (
  contentType: TemplateSlotContentType,
): TemplateSlotInputMode => {
  if (contentType === "ReportFooter") return "text";
  return "prompt";
};

/**
 * Sorted json-render component types a template slot may accept.
 * Includes Herald body components and Template Studio report-chrome components.
 */
export const TEMPLATE_SLOT_CONTENT_TYPES: readonly TemplateSlotContentType[] = [
  ...templateHeraldSlotContentTypes,
  ...templateReportSlotContentTypes,
].sort((left, right) => left.localeCompare(right));
